<i18n>
{
    "en":{
        "game_name": "MLB 9 Innings 26",
        "key_feature": "Key features",
        "feature1": "Auto play 24/7",
        "feature2": "Optimize energy usage",
        "feature3": "Auto daily/weekly missions",
        "feature4": "Auto club house check-in",
        "already_trying": "Start playing",
        "apply_free_trial": "Try for FREE",
        "go_simple_tutorial": "Quick start guide",
        "quickGuideURL": "https://sites.google.com/deltamon.com/mlb9inningsxrobotmon/en/xrobotmon-tutorial",
        "subscribe": "Subscribe Now"
    },
    "zhHant":{
        "game_name": "MLB 9局職棒26",
        "key_feature": "主要特點",
        "feature1": "24小時自動刷賽、排名賽",
        "feature2": "體力最佳化配置",
        "feature3": "自動每週每日任務",
        "feature4": "俱樂部自動打卡",
        "already_trying": "開始玩囉",
        "apply_free_trial": "馬上免費試用！",
        "go_simple_tutorial": "簡易使用教學",
        "quickGuideURL": "https://sites.google.com/deltamon.com/mlb9inningsxrobotmon/zh/xrobotmon-tutorial",
        "subscribe": "馬上訂閱！"
    },
    "ja":{
        "game_name": "MLB：9イニングス26",
        "key_feature": "主な機能",
        "feature1": "リーグ戦・ランク戦を24時間自動でプレイ",
        "feature2": "スタミナを無駄なく配分",
        "feature3": "デイリー・ウィークリーミッションを自動クリア",
        "feature4": "クラブハウスの自動チェックイン",
        "already_trying": "スタート",
        "apply_free_trial": "無料で試してみる",
        "go_simple_tutorial": "基本的な使い方",
        "quickGuideURL": "https://sites.google.com/deltamon.com/mlb9inningsxrobotmon/ja/xrobotmon-tutorial",
        "subscribe": "今すぐ登録する！"
    },
    "ko": {
        "game_name": "MLB 9이닝스 26",
        "key_feature": "주요 기능",
        "feature1": "24시간 자동으로 경기하기",
        "feature2": "에너지 최적화",
        "feature3": "매일/매주 미션 자동으로",
        "feature4": "클럽하우스 자동 체크인",
        "already_trying": "시작하기",
        "apply_free_trial": "무료 체험하기",
        "go_simple_tutorial": "사용방법 알아보기",
        "quickGuideURL": "https://sites.google.com/deltamon.com/mlb9inningsxrobotmon/en/xrobotmon-tutorial",
        "subscribe": "즉시 구독하기"
    }
}
</i18n>
<template>
  <div>
    <v-card class="mx-auto elevation-0 transparent">
      <v-card-title>
        <v-layout row wrap align-center>
          <v-flex xs9>
            <div class="title">{{ $t('game_name') }}</div>
          </v-flex>
          <v-flex xs3>
            <v-avatar tile size="80">
              <GameLogo :imageUrl="mlb9iLogoUrl" :width="80" :height="80" />
            </v-avatar>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text v-if="!small">
        <v-list dense style="background: none" subheader>
          <v-subheader>{{ $t('key_feature') }}</v-subheader>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>mdi-numeric-1-box-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>{{ $t('feature1') }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>mdi-numeric-2-box-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>{{ $t('feature2') }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>mdi-numeric-3-box-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>{{ $t('feature3') }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>mdi-numeric-4-box-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>{{ $t('feature4') }}</v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card-text>
      <v-card-actions v-if="!small">
        <v-btn color="green lighten-2" block dark outline :href="$t('quickGuideURL')" target="_blank">{{
          $t('go_simple_tutorial')
        }}</v-btn>
      </v-card-actions>
      <v-card-actions v-if="mode === 'trial'">
        <v-btn color="blue lighten-2" block dark @click="getTrial">
          {{ $t('apply_free_trial') }}
        </v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <v-btn color="blue lighten-2" block dark @click="subscribe">{{ $t('subscribe') }}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import assetMisc from '../assets/misc';
import GameLogo from '../components/ui/GameLogo.vue';

export default {
  name: 'MLB9IIntro',
  components: {
    GameLogo,
  },
  props: {
    mode: {
      type: String,
      default: 'trial', // 'trial' 'subscribe'
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return { mlb9iLogoUrl: assetMisc.mlb9iLogoUrl };
  },
  methods: {
    isEmpty(x) {
      return isEmpty(x);
    },
    getTrial() {
      this.$router.push(`/trial/mlb9i`);
    },
    subscribe() {
      this.$router.push(`/plan/mlb9i`);
    },
  },
};
</script>
